import { format, subDays } from "date-fns";
import { es } from "date-fns/locale";
import { getCurrentDateTemplate } from "../../shortcodes/templates";

const LOCALES = { es };

const DATE_SHORTCODE_REGEX =
  /\{\{\s*shortcodes\.date\(\s*"([^"]*)"\s*,\s*"([^"]*)"(?:\s*,\s*"([^"]*)"\s*,\s*"([^"]*)")?\s*\)\s*\}\}/g;

const applyCase = (value, variant, locale) => {
  if (variant === "lower") return value.toLowerCase();
  if (variant === "upper") return value.toUpperCase();
  if (locale && locale !== "en") {
    return value.replace(/(^|\s)(\p{Ll})/gu, (_, prefix, letter) => prefix + letter.toUpperCase());
  }
  return value;
};

const computeDatePreview = (pattern, offset, locale, variant) => {
  if (!pattern) return "";
  try {
    const offsetDays = parseInt(offset) || 0;
    const displayDate = subDays(new Date(), offsetDays);
    const formatOptions = LOCALES[locale] ? { locale: LOCALES[locale] } : {};
    const formatted = format(displayDate, pattern, formatOptions);
    return applyCase(formatted, variant || "default", locale || "en");
  } catch (ex) {
    return "";
  }
};

const readSpanData = (span, fmtFallback = "") => ({
  fmt: span.getAttribute("data-format") || fmtFallback,
  offset: span.getAttribute("data-offset") || "0",
  locale: span.getAttribute("data-locale") || "en",
  variant: span.getAttribute("data-case") || "default",
});

const buildDateSpan = (ownerDocument, fmt, offset, locale, variant) => {
  const span = ownerDocument.createElement("span");
  span.className = "dynamic-date-shortcode";
  span.setAttribute("data-format", fmt);
  span.setAttribute("data-offset", offset || "0");
  span.setAttribute("data-locale", locale || "en");
  span.setAttribute("data-case", variant || "default");
  span.setAttribute(
    "title",
    `Dynamic date → format: ${fmt}, offset: ${offset || "0"}, language: ${locale || "en"}, case: ${variant || "default"}`
  );
  span.textContent = `{{ ${computeDatePreview(fmt, offset, locale || "en", variant || "default")} }}`;
  return span;
};

const visualizeDate = content => {
  const root = content.body || content;
  const ownerDocument = root.ownerDocument || document;

  root.querySelectorAll(".dynamic-date-shortcode").forEach(span => {
    const { fmt, offset, locale, variant } = readSpanData(span);
    span.textContent = `{{ ${computeDatePreview(fmt, offset, locale, variant)} }}`;
  });

  if (!root.innerHTML.includes("shortcodes.date(")) return;
  root.innerHTML = root.innerHTML.replace(
    DATE_SHORTCODE_REGEX,
    (_, fmt, offset, locale, variant) =>
      buildDateSpan(ownerDocument, fmt, offset, locale || "en", variant || "default").outerHTML
  );
};

const serializeDate = content => {
  const root = content.body || content;
  root.querySelectorAll(".dynamic-date-shortcode").forEach(span => {
    const { fmt, offset, locale, variant } = readSpanData(span);
    const ownerDocument = span.ownerDocument || document;
    span.replaceWith(ownerDocument.createTextNode(getCurrentDateTemplate(fmt, offset, locale, variant)));
  });
};

export { visualizeDate, serializeDate, buildDateSpan, computeDatePreview, readSpanData };
